module.exports = __webpack_public_path__ + "static/img/cop_sch_logo18.617d465b.png";